export class LaboratoriosModel {
  id_laboratorio: number;
  nome: string;
}



// WEBPACK FOOTER //
// ./src/app/laboratorios/laboratorios.model.ts